module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/proveedores"
    }
  }, [_vm._v("Volver a la lista")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [(_vm.guardadoBD) ? _c('a', {
    attrs: {
      "href": "#usuarios",
      "aria-controls": "entradas",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Usuarios admin")]) : _vm._e()]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [(_vm.guardadoBD) ? _c('a', {
    attrs: {
      "href": "#vinculadas",
      "aria-controls": "entradas",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Empresas vinculadas")]) : _vm._e()]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [(_vm.guardadoBD) ? _c('a', {
    attrs: {
      "href": "#form-usuario",
      "aria-controls": "usuario",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Nuevo Usuario")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active in fade",
    attrs: {
      "role": "tabpanel",
      "id": "general"
    }
  }, [_c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Razón Social")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proveedor.razonSocial),
      expression: "proveedor.razonSocial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proveedor.razonSocial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proveedor.razonSocial = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.proveedor.razonSocial.minLength || !_vm.$v.proveedor.razonSocial.required) && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("La razon social debe tener por lo menos 3 caracteres")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Dirección")]), _vm._v(" "), (_vm.mapsLoaded) ? _c('vue-google-autocomplete', {
    ref: "direccion",
    attrs: {
      "id": "map",
      "country": "ar",
      "classname": "form-control",
      "placeholder": "Escriba la dirección"
    },
    on: {
      "placechanged": _vm.getAddressData
    }
  }) : _vm._e(), _vm._v(" "), ((!_vm.$v.proveedor.direccion.minLength || !_vm.$v.proveedor.direccion.required) && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe escribir una dirección")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Torre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proveedor.datosGeo.torre),
      expression: "proveedor.datosGeo.torre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proveedor.datosGeo.torre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proveedor.datosGeo.torre = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Piso")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proveedor.datosGeo.piso),
      expression: "proveedor.datosGeo.piso"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proveedor.datosGeo.piso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proveedor.datosGeo.piso = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Departamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proveedor.datosGeo.departamento),
      expression: "proveedor.datosGeo.departamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proveedor.datosGeo.departamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proveedor.datosGeo.departamento = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Combos y precios")]), _vm._v(" "), _c('div', {
    staticClass: "panel.panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Combo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comboForm.idCombo),
      expression: "comboForm.idCombo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comboForm.idCombo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Seleccione un combo")]), _vm._v(" "), _vm._l((_vm.combos), function(combo, idx) {
    return _c('option', {
      key: combo._id,
      domProps: {
        "value": combo._id
      }
    }, [_vm._v(_vm._s(combo.nombre))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comboForm.precio),
      expression: "comboForm.precio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.comboForm.precio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comboForm.precio = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 col-lg-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline btn-block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickGuardarCombo($event)
      }
    }
  }, [_vm._v("Agregar")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.proveedor.precios), function(precio, idx) {
    return _c('tr', {
      key: precio.combo
    }, [_c('td', [_vm._v(_vm._s(precio.combo.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearMoneda")(precio.precio)))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickEditPrecio(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-edit"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickRemoveCombo(precio.combo._id, idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-remove"
    })])])])])])
  }))]), _vm._v(" "), (!_vm.$v.proveedor.precios.minLength && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe agregar por lo menos un combo")]) : _vm._e(), _vm._v(" "), (!_vm.$v.proveedor.precios.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe agregar por lo menos un combo")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel fade",
      "id": "delivery"
    }
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo del delivery")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proveedor.costoDelivery),
      expression: "proveedor.costoDelivery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proveedor.costoDelivery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proveedor.costoDelivery = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horarios de entrega")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    ref: "timepicker",
    staticClass: "timepicker form-control",
    attrs: {
      "type": "text",
      "value": "12:00"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickAgregarHora($event)
      }
    }
  }, [_vm._v("Agregar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [((!_vm.$v.proveedor.horariosEntrega.minLength || !_vm.$v.proveedor.horariosEntrega.required) && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe agregar por lo menos un horario de entrega")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.proveedor.horariosEntrega), function(hora, idx) {
    return _c('tr', {
      key: hora
    }, [_c('td', [_vm._v(_vm._s(hora))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "href": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickRemoveHorario(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-remove"
    })])])])])])
  }))])])])])])])])]), _vm._v(" "), (_vm.guardadoBD) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel fade",
      "id": "usuarios"
    }
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn-link pull-right",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("Crear un nuevo usuario")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.usuariosAdmin), function(usuario) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(usuario.displayName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))]), _vm._v(" "), _c('td', [(usuario.activado) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [(usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Desactivar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-times"
    })])]) : _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Activar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-plus"
    })])])])])])
  }))])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.guardadoBD) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel fade",
      "id": "vinculadas"
    }
  }, [_c('div', {
    staticClass: "smart-form"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.sucursalesVinculadas.length > 0) ? [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.sucursalesVinculadas), function(sucursal) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sucursal.empresa.razonSocial) + "-" + _vm._s(sucursal.denominacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getNombreCombo(sucursal.comboSubsidiado)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sucursal.horaAsignada))])])
  }))])] : [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("El proveedor no tiene empresas asignadas")])]], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.guardadoBD) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "form-usuario"
    }
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.firstName),
      expression: "usuario.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.usuario.firstName.required && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.lastName),
      expression: "usuario.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.usuario.lastName.required && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.email = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.email.required || !_vm.$v.usuario.email.email) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Formato no válido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.telefonoCelular),
      expression: "usuario.telefonoCelular"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.telefonoCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.telefonoCelular = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.telefonoFijo),
      expression: "usuario.telefonoFijo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "De su área de trabajo"
    },
    domProps: {
      "value": (_vm.usuario.telefonoFijo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.telefonoFijo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Interno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.interno),
      expression: "usuario.interno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.interno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.interno = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.username),
      expression: "usuario.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.username = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.usuario.username.required && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.password),
      expression: "usuario.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.usuario.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.password = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.usuario.password.required && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Repetir contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.repeatPassword),
      expression: "usuario.repeatPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.usuario.repeatPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuario.repeatPassword = $event.target.value
      }
    }
  }), _vm._v(" "), ((!_vm.$v.usuario.repeatPassword.sameAsPassword) && _vm.mostrarErroresUsuario) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("No coincide con el password dado")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickGuardarUsuario($event)
      }
    }
  }, [_vm._v("GUARDAR")])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center center-block",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": _vm.onClickGuardarProveedor
    }
  }, [_vm._v("Guardar Proveedor")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#general",
      "aria-controls": "entradas",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Datos generales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#delivery",
      "aria-controls": "delivery",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Delivery y entregas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Combo")]), _vm._v(" "), _c('th', [_vm._v("Precio")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Hora")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Activo")]), _vm._v(" "), _c('th', {
    staticClass: "derecha"
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Combo asignado")]), _vm._v(" "), _c('th', [_vm._v("Horario de entrega")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("NUEVO USUARIO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Área")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Elija...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Atención al Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Administración")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Contaduría")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Área comercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recepción")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("DATOS DE ACCESO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff98ecc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Proveedores/Form.vue
// module id = 1173
// module chunks = 5